// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__8aWbg","content":"page_content__zkPDu","header":"page_header__T5hR0","title":"page_title__YRhE7","subtitle":"page_subtitle__xXRUp"};